import React from 'react';

const Spinner = ({color}) => {

  return(
    <div className={`html-spinner ${color === "primary" ? "spinner-primary" : ""}`}></div>
  );
}

export default Spinner;